module.exports = __webpack_public_path__ + "img/icon_calendar.3fdfd9ec.svg";